export default [
  {
    inputs: [{ internalType: 'address', name: '_weth', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      { internalType: 'address', name: 'socketVault', type: 'address' },
      { internalType: 'bool', name: 'isSCW', type: 'bool' },
      { internalType: 'uint256', name: 'gasLimit', type: 'uint256' },
      { internalType: 'address', name: 'connector', type: 'address' },
    ],
    name: 'depositETHToLyra',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'address', name: 'socketVault', type: 'address' },
      { internalType: 'bool', name: 'isSCW', type: 'bool' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'gasLimit', type: 'uint256' },
      { internalType: 'address', name: 'connector', type: 'address' },
    ],
    name: 'depositToLyra',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lightAccountFactory',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'weth',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  { stateMutability: 'payable', type: 'receive' },
] as const
